var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"Subscription Inactive","show-close-button":false,"show-cancel-button":false,"show-submit-button":_vm.$auth.user.owner || _vm.$auth.user.admin,"submit-text":"Upgrade","close-on-outside-click":false},on:{"submit":_vm.goToStripe}},[_c('div',{staticClass:"container"},[_c('p',[_vm._v(_vm._s(_vm.modalText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }